import React, { useEffect } from "react";
import Header from "../Header";
import Footer from "../Footer";
import { useDispatch, useSelector } from "react-redux";
import LoadingBox from "../LoadingBox";
import MessageBox from "../MessageBox";
import { JOB_CREATE_RESET, JOB_DELETE_RESET } from "../../constants/jobConstants";
import { createJob, deleteJob, listJobs } from "../../actions/jobActions";

export default function JobsListScreen(props) {
  const jobList = useSelector((state) => state.jobList);
  const { loading, error, products } = jobList;

  const jobCreate = useSelector((state) => state.jobCreate);
  const {
    loading: loadingCreate,
    error: errorCreate,
    success: successCreate,
    product: createdProduct,
  } = jobCreate;

  const jobDelete = useSelector((state) => state.jobDelete);
  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = jobDelete;

  const dispatch = useDispatch();
  useEffect(() => {
    if (successCreate) {
      dispatch({ type: JOB_CREATE_RESET });
      props.history.push(`/job/${createdProduct._id}/edit`);
    }
    if (successDelete) {
      dispatch({ type: JOB_DELETE_RESET });
    }
    dispatch(listJobs());
  }, [createdProduct, dispatch, props.history, successCreate, successDelete]);

  const deleteHandler = (product) => {
    if (window.confirm("Are you sure to delete?")) {
      dispatch(deleteJob(product._id));
      window.location.reload();
    }
  };
  const createHandler = () => {
    dispatch(createJob());
  };
  return (
    <div className="SCREEN-CONTAINER">
      <Header />
      <div
        className="MAIN backgroundcolor-f2f2f2"
        style={{ textAlign: "center" }}
      >
        <h1 style={{ padding: "20px 5px", fontWeight: "600" }}>Jobs List</h1>

        <div className="MenuBtnContainer">
          <button
            type="button"
            className="MenuBtn"
            style={{
              fontSize: "10px",
              fontWeight: "600",
              padding: "5px",
            }}
            onClick={createHandler}
          >
            Create Job
          </button>
        </div>

        {loadingDelete && <LoadingBox></LoadingBox>}
        {errorDelete && <MessageBox variant="danger">{errorDelete}</MessageBox>}
        {loadingCreate && <LoadingBox></LoadingBox>}
        {errorCreate && <MessageBox variant="danger">{errorCreate}</MessageBox>}
        {loading ? (
          <LoadingBox></LoadingBox>
        ) : error ? (
          <MessageBox variant="danger">{error}</MessageBox>
        ) : (
          <div className="scrollTableH">
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>TITLE</th>
                <th>DESCRIPTION</th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product) => (
                <tr key={product._id}>
                  <td>{product._id}</td>
                  <td>{product.name}</td>
                  <td>{product.description}</td>
                  <td>
                    <div className="MenuBtnContainer">
                      <button
                        type="button"
                        className="MenuBtn"
                        style={{
                          fontSize: "10px",
                          fontWeight: "600",
                          padding: "5px",
                        }}
                        onClick={() =>
                          props.history.push(`/job/${product._id}/edit`)
                        }
                      >
                        Edit
                      </button>
                    </div>

                    <div className="MenuBtnContainer">
                      <button
                        type="button"
                        className="MenuBtn"
                        style={{
                          fontSize: "10px",
                          fontWeight: "600",
                          padding: "5px",
                        }}
                        onClick={() => deleteHandler(product)}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
